/**
 @description 新闻动态

 banner
 title thumb url listorder status

 News
 title desc url thumb listorder block

 aboutZtx
 title thumb desc

 [
 'banner' , 'aboutZtx' , '..' ..
 ]

 http://test.madailicai.com/cms-web-api/config/banner

 */
import React, { Component } from 'react'

import './News.scss';

class News extends Component {

  render(){
    let homeNews=this.props.homeNews && this.props.homeNews
    return (
      <div id="news" className="newsContent">
        <h1><img src={require('./images/news.png')}/> </h1>
        <ul>
          {
            homeNews.map((newsItem, i) => {
              return (
                <li key={i}>
                  <a href={newsItem.url}>
                    <img src={newsItem.thumb}  alt={newsItem.title} title={newsItem.title} />
                    <span className="newsTitle">{newsItem.title}</span>
                  </a>
                </li>
              )
            })

          }
        </ul>
        <p className="more">
          <a href={this.props.menuChilderUrl('aboutUs','news')} >更多资讯</a>
        </p>
      </div>
    )
  }
}
export { News }



// WEBPACK FOOTER //
// ./modules/home/News.js